import { IconButton } from '@dev-spendesk/grapes';
import { useState, useEffect, useCallback, useMemo } from 'react';

import SettingsGuideCustom3 from './assets/headerLevel/settings-guide-custom-3.png';
import SettingsGuideCustom4 from './assets/headerLevel/settings-guide-custom-4.png';
import SettingsGuideCustom5 from './assets/headerLevel/settings-guide-custom-5.png';
import SettingsGuideCustom6 from './assets/headerLevel/settings-guide-custom-6.png';
import SettingsGuideStandart1 from './assets/headerLevel/settings-guide-standart-1.png';
import SettingsGuideStandart2 from './assets/headerLevel/settings-guide-standart-2.png';

export const LearnHowToChangeIllustration = ({
  selectedTab,
  exportLevel,
}: {
  selectedTab: 'current' | 'recommended';
  exportLevel: 'header' | 'headerLine';
}) => {
  // Collect images based on tab. For now we only have two source files.
  const images = useMemo(() => {
    if (selectedTab === 'current') {
      return [SettingsGuideStandart1, SettingsGuideStandart2];
    }

    if (exportLevel === 'header') {
      return [
        SettingsGuideStandart1,
        SettingsGuideStandart2,
        SettingsGuideCustom3,
        SettingsGuideCustom4,
        SettingsGuideCustom5,
        SettingsGuideCustom6,
      ];
    }

    return [SettingsGuideCustom3, SettingsGuideCustom4, SettingsGuideCustom5];
  }, [selectedTab, exportLevel]);

  useEffect(() => {
    setIndex(0); // Reset index when images change
  }, [images]);

  const [index, setIndex] = useState(0);
  const total = images.length;

  const goPrevious = useCallback(() => {
    setIndex((currentIndex) =>
      currentIndex === 0 ? total - 1 : currentIndex - 1,
    );
  }, [total]);
  const goNext = useCallback(() => {
    setIndex((currentIndex) =>
      currentIndex === total - 1 ? 0 : currentIndex + 1,
    );
  }, [total]);

  return (
    <div className="flex h-full w-full items-center justify-center bg-gray-50">
      <div className="relative flex h-full w-full max-w-[640px] flex-col items-center justify-center p-4">
        <div className="flex w-full items-center justify-center gap-40">
          <IconButton
            variant="secondaryNeutral"
            iconName="arrow-left"
            aria-label="Previous"
            onClick={goPrevious}
          />
          <div className="flex h-full flex-1 items-center justify-center">
            <img
              src={images[index]}
              alt={`${selectedTab} illustration ${index + 1}`}
              className="w-[480px] object-contain"
            />
          </div>
          <IconButton
            variant="secondaryNeutral"
            iconName="arrow-right"
            aria-label="Next"
            onClick={goNext}
          />
        </div>
        <div className="mt-32 text-xs text-gray-500">
          NetSuite: Step {index + 1}/{total}
        </div>
      </div>
    </div>
  );
};
